module.exports = __webpack_public_path__ + "img/Icelandlogo.6b80d5be.svg";